/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Impero API
 * Legacy Impero .NET API (served under /v1).
 */

export type LegacyControlFieldName =
    (typeof LegacyControlFieldName)[keyof typeof LegacyControlFieldName];

export const LegacyControlFieldName = {
    ControlProgram: "ControlProgram",
    Title: "Title",
    Description: "Description",
    Calendar: "Calendar",
    ControlTags: "ControlTags",
    CoveredPeriod: "CoveredPeriod",
    Due: "Due",
    Reminders: "Reminders",
    LoginProtectionEnabled: "LoginProtectionEnabled",
    Assignee: "Assignee",
    AssigneeGroup: "AssigneeGroup",
    AssigneeTags: "AssigneeTags",
    Reviewer: "Reviewer",
    LastUpdated: "LastUpdated",
    LastUpdatedBy: "LastUpdatedBy",
    DefaultClaimant: "DefaultClaimant",
    NotificationRecipients: "NotificationRecipients",
    SegregationOfDutiesEnforced: "SegregationOfDutiesEnforced",
    Entity: "Entity",
} as const;
